<template>
	<ValidationForm #default="{ handleSubmit, invalid }">
		<Modal width="600px">
			<template #modal-title>
				{{ (isEdit ? 'Edit' : 'Add') | useLabels }} {{ 'Rule' | useLabels }}
			</template>
			<template #modal-content>
				<div class="cassie-vertical-md">
					<TextField
						v-model.number="formRule.mergePass"
						:label="'Pass *' | useLabels"
						type="number"
						tooltip-text="Set the pass number this rule belongs to. Passes run sequentially."
						:rules="{ required: true, min_value: 1, max_value: maxPassNumber }"
					/>
					<Dropdown
						v-model="formRule.fieldName"
						:label="'Field Name *' | useLabels"
						:items="fieldNameItems"
						custom-sort
						tooltip-text="Select a Syrenis Contact Field for this rule."
						rules="required"
					/>
					<Dropdown
						v-model="behavior"
						:label="'Behavior *' | useLabels"
						:items="behaviorItems"
						custom-sort
						test-id="add-edit-rule-behavior"
						tooltip-text="Controls how blank values are matched. Exact requires a value; the other options allow or require the field to be blank/null in the submission and CMP."
						rules="required"
					/>
					<v-row dense>
						<v-col
							cols="6"
							dense
						>
							<Toggle
								:value.sync="formRule.isActive"
								:label="'Is Active *' | useLabels"
								aligned-toggles
								tooltip-text="Enable or disable this specific rule."
							/>
						</v-col>
					</v-row>
				</div>
			</template>
			<template #modal-footer>
				<SecondaryActionButton
					test-id="add-edit-rule-cancel-button"
					@click="$emit('cancel')"
				>
					{{ 'Cancel' | useLabels }}
				</SecondaryActionButton>
				<PrimaryActionButton
					test-id="add-edit-rule-save-button"
					:disabled="invalid"
					@click="handleSubmit(submit)"
				>
					{{ (isEdit ? 'Save' : 'Create') | useLabels }}
				</PrimaryActionButton>
			</template>
		</Modal>
	</ValidationForm>
</template>

<script>
import Modal from '../../../../../../../shared/components/modal.vue'
import TextField from '../../../../../../../shared/components/text-field.vue'
import Dropdown from '../../../../../../../shared/components/dropdown.vue'
import Toggle from '../../../../../../../shared/components/toggle.vue'
import PrimaryActionButton from '../../../../../../../shared/components/primary-action-button.vue'
import SecondaryActionButton from '../../../../../../../shared/components/secondary-action-button.vue'
import ValidationForm from '../../../../../../../shared/components/validation-form.vue'
import { BEHAVIOR_ITEMS, behaviorValueFromFlags, flagsFromBehaviorValue } from '../utils/behavior-options.js'

export default {
	name: 'add-edit-rule-modal',
	components: { Modal, TextField, Dropdown, Toggle, PrimaryActionButton, SecondaryActionButton, ValidationForm },
	props: {
		ruleToEdit: { type: Object, default: null },
		fieldNameItems: { type: Array, default: () => [] },
		maxPassNumber: { type: Number, required: true },
		defaultMergePass: { type: Number, default: 1 }
	},
	data () {
		return {
			formRule: this.ruleToEdit
				? JSON.parse(JSON.stringify(this.ruleToEdit))
				: {
					id: null,
					mergePass: this.defaultMergePass,
					fieldName: '',
					allowBlanks: false,
					mustBeBlank: false,
					updateDetails: false,
					isActive: true
				}
		}
	},
	computed: {
		isEdit () { return Boolean(this.ruleToEdit) },
		behaviorItems () {
			return BEHAVIOR_ITEMS
		},
		behavior: {
			get () {
				return behaviorValueFromFlags(this.formRule.allowBlanks, this.formRule.mustBeBlank)
			},
			set (value) {
				const { allowBlanks, mustBeBlank } = flagsFromBehaviorValue(value)
				this.formRule.allowBlanks = allowBlanks
				this.formRule.mustBeBlank = mustBeBlank
			}
		}
	},
	methods: {
		submit () { this.$emit('save', this.formRule) }
	}
}
</script>
